@if (data().signatureIsRequired && !userHasSignature()) {
    <div class="p-b m-b cipo--border-bottom--lite" data-testid="transition-dialog-signature-section">
        <div class="cipo-bg--warn-100 cipo-text--medium-lg cipo--text--center">
            {{ "signature.signatureRequired" | translate }}
        </div>
        <cipo-signature (currentSignatureChange)="userHasSignature.set(true)" />
    </div>
}

<cipo-dynamic-form
    #dynamicForm
    [contractId]="data().contractId"
    [readonly]="false"
    [fields]="data().fields"
    [form]="form()"
    (formValuesPrepared)="handleSubmit($event)" />

@if (notificationData()) {
    <div class="m-t">
        <cipo-notification-form
            [data]="notificationData()"
            [compactMode]="compactMode()"
            (valueChanged)="onNotificationValueChanged($event)" />
    </div>
}
